var _defs, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    "data-sanitized-data-name": "Layer 1",
    "data-name": "Layer 1",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7b3623;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke: #f9d53b;\n        stroke-width: 2.99px;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        stroke: #4f2a22;\n        stroke-width: 8px;\n      }\n\n      .cls-5 {\n        fill: #4f2a22;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m292.66,237.9c.18,0,.35,0,.53.03h-1.05c.17-.02.35-.03.53-.03",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.73,237.92c.1,0,.21,0,.31.01h-.62c.1,0,.21-.01.31-.01",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.42,237.93c-.08,0-.16.01-.24.02v-.02h.24",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 230.5,
    cy: 250,
    cx: 250,
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 223,
    cy: 250,
    cx: 250,
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m314.4,254.6v-108.1c0-2.53-2.07-4.6-4.6-4.6h-119.6c-2.53,0-4.6,2.07-4.6,4.6v108.1c0,2.53,2.07,4.6,4.6,4.6h119.6c2.53,0,4.6-2.07,4.6-4.6Zm-9.2-4.6h-110.4v-98.9h110.4v98.9Z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m300.6,102.8h-101.2c-29.21,0-52.9,23.69-52.9,52.9v133.4c0,29.21,23.69,52.9,52.9,52.9h18.4v50.6c0,2.53,2.07,4.6,4.6,4.6h55.2c2.53,0,4.6-2.07,4.6-4.6v-50.6h18.4c29.21,0,52.9-23.69,52.9-52.9v-133.4c0-29.21-23.69-52.9-52.9-52.9Zm-27.6,285.2h-46v-82.8h46v82.8Zm71.3-98.9c0,24.15-19.55,43.7-43.7,43.7h-18.4v-27.6h9.2c2.53,0,4.6-2.07,4.6-4.6s-2.07-4.6-4.6-4.6h-82.8c-2.53,0-4.6,2.07-4.6,4.6s2.07,4.6,4.6,4.6h9.2v27.6h-18.4c-24.15,0-43.7-19.55-43.7-43.7v-133.4c0-24.15,19.55-43.7,43.7-43.7h101.2c24.15,0,43.7,19.55,43.7,43.7v133.4Z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250,378.8c7.59,0,13.8-6.21,13.8-13.8s-6.21-13.8-13.8-13.8-13.8,6.21-13.8,13.8,6.21,13.8,13.8,13.8Zm0-18.4c2.53,0,4.6,2.07,4.6,4.6s-2.07,4.6-4.6,4.6-4.6-2.07-4.6-4.6,2.07-4.6,4.6-4.6Z",
    className: "cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m250,236.2c13.57,0,24.84-11.04,24.84-24.61,0-25.07-20.93-44.62-21.62-45.31-1.84-1.61-4.6-1.61-6.44.23-.92.92-21.62,22.77-21.62,45.08,0,13.57,11.27,24.61,24.84,24.61h0Zm.23-59.8c5.29,6.21,15.41,19.78,15.41,35.19,0,8.74-7.13,15.64-15.64,15.64s-15.64-6.9-15.64-15.64c0-14.03,10.35-28.75,15.87-35.19Z",
    className: "cls-5"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 222.5,
    cy: 250,
    cx: 250,
    className: "cls-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.fc2041e1197c3f72d447a34c12065ac4.svg";
export { ForwardRef as ReactComponent };